import {
  USERDETAILS,
  APPTOKEN,
  LOGINTOKEN,
  LOGOUT,
  LOGOUT_SUCCESS,
  VENDORDETAILS,
  CUSTOMERID,
  SET_LOCATION,
  ADD_PRODUCT_TO_STORE,
  ADDTO_CART,
  SET_MODAL_PROPERTIES,
  Remove_Item_FROM_CART,
  UPDATE_CART_QUANTITY,
  RESET_CART,
  GET_PRIMARY_ADDRESS,
  SET_DELIVERY_MODE,
  GET_SHOP_DETAILS,
  UPDATE_CART_TOTAL,
  GET_COUPON_CODE,
  GET_COUPON_AMOUNT,
  GET_SITE_SETTINGS,
  SET_FINAL_PAY_AMOUNT,
  SET_SITE_SETTINGS_CHARGES,
  SET_PLATFORM_FEES,
  SET_DELIVERY_PARTNER_FEES,
  SET_GST_CHARGES,
  SET_COUPON_AMOUNT,
  USERLOGINNUMBER,
} from "../constants";

const initialState = {
  userdetails: {
    email: "",
    first_name: "",
    mobile_number: "",
    last_name: "",
    profile: "",
    token: "",
  },
  userLoginNumber:{},
  vendordata: {},

  userlogged: {
    isFirsttime: false,
  },
  logoutMessage: "",
  apptoken: "",
  logintoken: "",
  customerId: "",
  userLocation: {
    latitude: null,
    longitude: null,
    changedAddress: null,
  },
  productDetails: {},
  cartDetails: {
    items: [],
    total: 0,
  },
  modalProperties: {
    showModal: false,
    modalMessage: "",
  },
  primaryAddress: null,
  mode: "home delivery",
  shopDetails: {},
  couponCode: null,
  couponAmount: 0,
  siteSettings: {},
  finalPayAmount: 0,
  siteSettingsCharges: 0,
  platformFees: 0,
  deliveryPartnerFees: 0,
  gstCharges: 0,
};

const UserReducer = (state = initialState, action) => {
  console.log("action..type", action.type);

  switch (action.type) {
    case USERDETAILS:
      return {
        ...state,
        userdetails: action.userData,
        isLoading: false,
      };

    case USERLOGINNUMBER:
      return {
        ...state,
        userLoginNumber: action.userLoginNumber,
      };

    case VENDORDETAILS:
      return {
        ...state,
        vendordata: action.vendordata,
        isLoading: false,
      };
    case APPTOKEN:
      console.log("action_em", action.apptoken);
      return {
        ...state,
        apptoken: action.apptoken,
      };

    case LOGINTOKEN:
      console.log("action_em logintoken", action.logintoken);
      return {
        ...state,
        logintoken: action.logintoken,
      };
    case LOGOUT:
      return {
        ...state,
        logintoken: null,
        userdetails: {
          email: "",
          first_name: "",
          mobile_number: "",
          last_name: "",
          profile: "",
          token: "",
        },
        apptoken: null,
        // isAuthenticated: false
      };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        logoutMessage: action.payload.message,
      };

    case CUSTOMERID:
      console.log("action_em customerId", action.customerId);
      return {
        ...state,
        customerId: action.customerId,
      };
    case SET_LOCATION:
      return {
        ...state,
        userLocation: {
          latitude: action.payload.latitude,
          longitude: action.payload.longitude,
          changedAddress: action.payload.changedAddress,
        },
      };
    case ADD_PRODUCT_TO_STORE:
      return {
        ...state,
        productDetails: action.payload,
      };

    case ADDTO_CART: {
      console.log("action..payload", action.payload);
      const { item, modification } = action.payload;

      //   if (modification) {

      //   const updatedTotal = state.cartDetails.items.reduce((sum, currentItem) => {
      //     const itemPrice = parseFloat(currentItem.price) || 0;
      //     return sum + itemPrice * currentItem.quantity;
      //   }, 0);

      //   const finalPay = updatedTotal + 8;
      //   console.log("action..modification finalPay", finalPay);

      //   return {
      //     ...state,
      //     cartDetails: {
      //       ...state.cartDetails,
      //       total: updatedTotal,
      //       finalPay: finalPay,
      //     },
      //   };
      // }

      if (modification) {
        console.log("action..modification", modification);
        // const charges =
        //   Number(state.platformFees || 0) +
        //   Number(state.deliveryPartnerFees || 0) +
        //   Number(state.gstCharges || 0) -
        //   Number(state.couponAmount || 0);
        return {
          ...state,
          cartDetails: {
            items: item.items,
            total: item.total,
            // finalPay: item.finalPay + charges,
            finalPay: item.finalPay,
          },
        };
      }

      const newItems = Array.isArray(action.payload.item)
        ? action.payload.item
        : [action.payload.item];

      const updatedItems = [...state.cartDetails.items];

      console.log("updatedItems  0", updatedItems);
      console.log("newItems", newItems);
      newItems.forEach((newItem) => {
        const index = updatedItems.findIndex(
          (item) => item.vendor_product_id === newItem.vendor_product_id,
        );

        if (index !== -1) {
          updatedItems[index].quantity += 1;
        } else {
          updatedItems.push(newItem);
        }
      });

      console.log("updatedItems 1", updatedItems);

      const newTotal = updatedItems.reduce((sum, item) => {
        return sum + parseFloat(item.price) * item.quantity;
      }, 0);

      console.log("reducer sum", newTotal);
      //const shippingCost = 8;
      // const finalPay = newTotal + shippingCost;
      // return {
      //   ...state,
      //   cartDetails: {
      //     items: updatedItems,
      //     total: newTotal,
      //     finalPay : newTotal + 8
      //   },
      // };

      // const finalPay =
      //   newTotal +
      //   Number(state.platformFees || 0) +
      //   Number(state.deliveryPartnerFees || 0) +
      //   Number(state.gstCharges || 0) -
      //   Number(state.couponAmount || 0);

      const finalPay = newTotal;

      return {
        ...state,
        cartDetails: {
          items: updatedItems,
          total: newTotal,
          finalPay: finalPay,
        },
      };
    }

    case Remove_Item_FROM_CART: {
      console.log("action..payload", action.payload);
      const itemToRemove = action.payload; // expects { vendor_product_id: "..." }
      console.log("itemToRemove", itemToRemove);
      console.log("itemToRemove", state.cartDetails.items);
      const updatedItems = state.cartDetails.items.filter(
        (item) => item.vendor_product_id !== itemToRemove,
      );

      console.log("updatedItems", updatedItems);
      const newTotal = updatedItems.reduce((sum, item) => {
        return sum + parseFloat(item.price) * item.quantity;
      }, 0);
      // const finalPay =
      //   newTotal +
      //   Number(state.platformFees || 0) +
      //   Number(state.deliveryPartnerFees || 0) +
      //   Number(state.gstCharges || 0) -
      //   Number(state.couponAmount || 0);
      const finalPay = newTotal;
      return {
        ...state,
        cartDetails: {
          items: updatedItems,
          total: newTotal,
          //finalPay : newTotal + 8
          finalPay: finalPay,
        },
      };
    }

    case UPDATE_CART_QUANTITY: {
      const updatedItems = state.cartDetails.items.map((item) =>
        item.vendor_product_id === action.payload.vendor_product_id
          ? { ...item, quantity: action.payload.quantity }
          : item,
      );

      const newTotal = updatedItems.reduce(
        (sum, item) => sum + parseFloat(item.price) * item.quantity,
        0,
      );

      // const finalPay =
      //   newTotal +
      //   Number(state.platformFees || 0) +
      //   Number(state.deliveryPartnerFees || 0) +
      //   Number(state.gstCharges || 0) -
      //   Number(state.couponAmount || 0);
      const finalPay = newTotal;
      return {
        ...state,
        cartDetails: {
          items: updatedItems,
          total: newTotal,
          //finalPay : newTotal + 8
          finalPay: finalPay,
        },
      };
    }

    case RESET_CART:
      return {
        ...state,
        cartDetails: {
          items: [],
        },
      };
    case UPDATE_CART_TOTAL:
      return {
        ...state,
        total: action.payload,
      };
    case SET_MODAL_PROPERTIES:
      return {
        ...state,
        modalProperties: {
          ...state.modalProperties,
          ...action.payload,
        },
      };
    case GET_PRIMARY_ADDRESS:
      return {
        ...state,
        primaryAddress: action.payload,
      };
    case SET_DELIVERY_MODE:
      return { ...state, mode: action.payload };
    case GET_SHOP_DETAILS:
      return { ...state, shopDetails: action.payload };
    case GET_COUPON_CODE:
      return {
        ...state,
        couponCode: action.payload,
      };
    case GET_COUPON_AMOUNT:
      return {
        ...state,
        couponAmount: action.payload,
      };
    case GET_SITE_SETTINGS:
      return {
        ...state,
        siteSettings: action.payload,
      };
    case SET_FINAL_PAY_AMOUNT:
      return {
        ...state,
        finalPayAmount: action.payload,
      };
    case SET_SITE_SETTINGS_CHARGES:
      return {
        ...state,
        siteSettingsCharges: action.payload,
      };
    case SET_PLATFORM_FEES:
      return {
        ...state,
        platformFees: action.payload,
      };
    case SET_DELIVERY_PARTNER_FEES:
      return {
        ...state,
        deliveryPartnerFees: action.payload,
      };
    case SET_GST_CHARGES:
      return {
        ...state,
        gstCharges: action.payload,
      };
    case SET_COUPON_AMOUNT:
      return {
        ...state,
        couponAmount: action.payload,
      };

    default:
      return state;
  }
};
export default UserReducer;
